var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendarIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "calendar_4_",
    "data-name": "calendar (4)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_24887",
    "data-name": "Group 24887"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24886",
    "data-name": "Group 24886"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1157",
    "data-name": "Ellipse 1157",
    cx: 1,
    cy: 0.5,
    rx: 1,
    ry: 0.5,
    transform: "translate(13.5 7.5)",
    fill: "#d9a239"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36435",
    "data-name": "Path 36435",
    d: "M16.031,1.484h-.965V.742a.742.742,0,0,0-1.484,0v.742H10.205V.742a.742.742,0,0,0-1.484,0v.742H5.381V.742A.742.742,0,0,0,3.9.742v.742H2.969A2.972,2.972,0,0,0,0,4.453V16.031A2.972,2.972,0,0,0,2.969,19H8.646a.742.742,0,0,0,0-1.484H2.969a1.486,1.486,0,0,1-1.484-1.484V4.453A1.486,1.486,0,0,1,2.969,2.969H3.9v.742a.742.742,0,0,0,1.484,0V2.969h3.34v.742a.742.742,0,0,0,1.484,0V2.969h3.377v.742a.742.742,0,0,0,1.484,0V2.969h.965a1.486,1.486,0,0,1,1.484,1.484v4.23a.742.742,0,0,0,1.484,0V4.453A2.972,2.972,0,0,0,16.031,1.484Z",
    fill: "#d9a239"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36436",
    "data-name": "Path 36436",
    d: "M274.49,270a4.49,4.49,0,1,0,4.49,4.49A4.5,4.5,0,0,0,274.49,270Zm0,7.5a3.006,3.006,0,1,1,3.006-3.006A3.009,3.009,0,0,1,274.49,277.5Z",
    transform: "translate(-259.98 -259.98)",
    fill: "#d9a239"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36437",
    "data-name": "Path 36437",
    d: "M372.818,331.521h-.334v-.779a.742.742,0,0,0-1.484,0v1.521a.742.742,0,0,0,.742.742h1.076a.742.742,0,0,0,0-1.484Z",
    transform: "translate(-357.232 -317.754)",
    fill: "#d9a239"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1158",
    "data-name": "Ellipse 1158",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    transform: "translate(10.5 7.5)",
    fill: "#d9a239"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1159",
    "data-name": "Ellipse 1159",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    transform: "translate(7.5 10.5)",
    fill: "#d9a239"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1160",
    "data-name": "Ellipse 1160",
    cx: 1,
    cy: 0.5,
    rx: 1,
    ry: 0.5,
    transform: "translate(3.5 7.5)",
    fill: "#d9a239"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1161",
    "data-name": "Ellipse 1161",
    cx: 1,
    cy: 0.5,
    rx: 1,
    ry: 0.5,
    transform: "translate(3.5 10.5)",
    fill: "#d9a239"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1162",
    "data-name": "Ellipse 1162",
    cx: 1,
    cy: 0.5,
    rx: 1,
    ry: 0.5,
    transform: "translate(3.5 13.5)",
    fill: "#d9a239"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1163",
    "data-name": "Ellipse 1163",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    transform: "translate(7.5 13.5)",
    fill: "#d9a239"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1164",
    "data-name": "Ellipse 1164",
    cx: 0.5,
    cy: 0.5,
    r: 0.5,
    transform: "translate(7.5 7.5)",
    fill: "#d9a239"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendarIcon.d266e30be3cc5f20924cf69a19d32b41.svg";
export { ForwardRef as ReactComponent };